import { useMemo } from 'react';

import useVisitStore from '../stores/visitStore';
import { useScope } from '../context/PermissionContext';

/**
 * useOwnDoctorSpecialization — the logged-in doctor's own specialization,
 * read from the org's already-hydrated doctor roster (`useVisitStore().doctors`,
 * populated by `hydrateDashboard()` / `SmartWorkflowWidget` on dashboard mount).
 *
 * Fires NO fetch of its own — it only selects from state that's already
 * loaded elsewhere in the dashboard tree. If the roster hasn't hydrated yet,
 * or the member isn't found (e.g. non-doctor role), returns ''.
 *
 * Used as the fallback for `doctorSpecialization` when a visit carries no
 * `doctor_specialization` of its own (e.g. no doctor assigned yet), so the
 * symptom picker shows the logged-in doctor's specialised list instead of
 * silently falling back to COMMON-only.
 */
export default function useOwnDoctorSpecialization() {
  const { memberId } = useScope();
  const doctors = useVisitStore((s) => s.doctors);

  return useMemo(
    () => doctors?.find((d) => d.member_id === memberId)?.specialization || '',
    [doctors, memberId]
  );
}
